module.exports = __webpack_public_path__ + "img/data-nav.a8c5f67c.png";